import React, { forwardRef, useEffect, useRef } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";
import { getImagePath } from "../../utilities/path";
import Picture from "../Picture";

export interface IOneImageProps extends IEditableProps, IStyledProps {
    backgroundImage: string;
    backgroundAlt: string;
    backgroundHeight: number;
    backgroundWidth: number;
    containerMobileHeight: number;
    containerDesktopHeight: number;
    pictureClassName: string;
}

const OneImage = forwardRef((props: IOneImageProps, ref: any) => {
    const { className, editorClassObj, cmsId, backgroundImage = '', pictureClassName = '' } = props;
    const containerRef = useRef();
    const backgroundImageRef = useRef();
    const speed = 0.3;

    const scrollEffect = (gsap) => {
        gsap.to(backgroundImageRef.current, {
            duration: 1,
            objectPosition: `0% ${100 * speed}%`,
            ease: 'none',
            scrollTrigger: {
                trigger: containerRef.current,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            }
        });
    }

    useEffect(() => {
        Promise.all([
            import("gsap"),
            import("gsap/ScrollTrigger"),
        ]).then(([module, plugin]) => {
            module.gsap.registerPlugin(plugin.ScrollTrigger);
            scrollEffect(module.gsap);
        });
    }, []);

    return (
        <div data-id={cmsId} ref={ref} className={classNames(className, editorClassObj, 'd-flex w-100')}>
            <div ref={containerRef} className="parallax-container w-100">
                <Picture
                    loading="lazy"
                    pictureClassName="parallax-picture d-flex"
                    className={classNames("parallax-img", pictureClassName)}
                    imgRef={backgroundImageRef}
                    src={getImagePath(backgroundImage)}
                    alt={props.backgroundAlt}
                ></Picture>
            </div>
      </div>
    );
});

export default styled(OneImage)`
    height: 100%;

    .parallax-container {
        position: relative;
        height: ${props => props.containerDesktopHeight == 0 ? '100%' : props.containerDesktopHeight + 'px'};
        @media (max-width: 991px) {
            height: ${props => props.containerMobileHeight}px;
        }
    }
    .parallax-picture {
        height: ${props => props.backgroundHeight}%;
        width: ${props => props.backgroundWidth}%;
        margin-left: ${props => (100 - props.backgroundWidth) / 2}%;
        @media (min-width: 992px) {
            position: absolute;
        }
    }
    .parallax-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 0 0;
    }
`;